import { createAction, ActionWithPayload } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { IRequestCourseModel } from '../../models/requestCourse.model'

import { EditRequestCourseAction } from 'store/sagas/courses/editRequestCourse.saga'
import { Query } from 'api/requestCourses/ListAdmin'
import { CreateRequestCourseAction } from '../sagas/courses/createRequestCourse.saga'

export const REQUEST_OUTSIDE_COURSES_GET_LIST_SUPERVISOR =
  'REQUEST_OUTSIDE_COURSES_GET_LIST_SUPERVISOR'
export const REQUEST_OUTSIDE_COURSES_GET_LIST_SUPERVISOR_SUCCESS =
  'REQUEST_OUTSIDE_COURSES_GET_LIST_SUPERVISOR_SUCCESS'
export const REQUEST_OUTSIDE_COURSES_GET_LIST_ADMIN =
  'REQUEST_OUTSIDE_COURSES_GET_LIST_ADMIN'
export const REQUEST_OUTSIDE_COURSES_GET_LIST_ADMIN_SUCCESS =
  'REQUEST_OUTSIDE_COURSES_GET_LIST_ADMIN_SUCCESS'
export const REQUEST_OUTSIDE_COURSES_LOADING = 'REQUEST_OUTSIDE_COURSES_LOADING'
export const CREATE_REQUEST_OUTSIDE_COURSE = 'CREATE_REQUEST_OUTSIDE_COURSE'
export const EDIT_REQUEST_OUTSIDE_COURSE = 'EDIT_REQUEST_OUTSIDE_COURSE'
export const DESTROY_REQUEST_OUTSIDE_COURSE = 'DESTROY_REQUEST_OUTSIDE_COURSE'

interface RequestOutsideCoursesGetListPayload {
  q?: Query
}

export type RequestOutsideCoursesGetListAction = ActionWithPayload<
  typeof REQUEST_OUTSIDE_COURSES_GET_LIST_SUPERVISOR,
  RequestOutsideCoursesGetListPayload
>

export const Actions = {
  create: (data: CreateRequestCourseAction['payload']) =>
    createAction(CREATE_REQUEST_OUTSIDE_COURSE, data),
  edit: (data: EditRequestCourseAction['payload']) =>
    createAction(EDIT_REQUEST_OUTSIDE_COURSE, data),
  getListSupervisor: (payload?: RequestOutsideCoursesGetListPayload) =>
    createAction(REQUEST_OUTSIDE_COURSES_GET_LIST_SUPERVISOR, payload),
  setListSupervisorSuccess: (data: IRequestCourseModel[]) =>
    createAction(REQUEST_OUTSIDE_COURSES_GET_LIST_SUPERVISOR_SUCCESS, {
      data,
    }),
  getListAdmin: (payload?: RequestOutsideCoursesGetListPayload) =>
    createAction(REQUEST_OUTSIDE_COURSES_GET_LIST_ADMIN, payload),
  setListAdminSuccess: (data: IRequestCourseModel[]) =>
    createAction(REQUEST_OUTSIDE_COURSES_GET_LIST_ADMIN_SUCCESS, {
      data,
    }),
  setLoading: (loading: boolean) =>
    createAction(REQUEST_OUTSIDE_COURSES_LOADING, { loading }),
}

export type Actions = ActionsUnion<typeof Actions>
